var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _circle, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _polygon, _polygon2, _polygon3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle2, _path31, _path32, _path33, _path34, _rect33, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect34, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _rect35, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _rect36, _path59, _path60, _circle3, _circle4, _circle5, _polygon4, _rect37, _rect38, _path61, _path62, _polygon5, _rect39, _path63, _path64, _polygon6, _path65, _rect40, _path66, _path67, _path68, _path69, _polygon7, _polygon8, _path70, _polygon9, _path71, _polygon10, _rect41, _path72, _polygon11, _path73, _path74, _rect42, _path75, _ellipse, _rect43, _path76, _polygon12, _polygon13, _polygon14, _path77, _polygon15, _polygon16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoanCreditAuthGraphicDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 865.76 682.89",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.81,
    y: 49.55,
    width: 320.67,
    height: 408.12,
    rx: 8.82,
    fill: "#21272D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.71,
    y: 68.11,
    width: 289.75,
    height: 374.55,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 243.07,
    y: 57.83,
    width: 139.22,
    height: 36.71,
    rx: 4,
    fill: "#e1e1e2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.28,27.11H270.8a5.71,5.71,0,0,0-5.71,5.71V62.45h4.62V35.4a3.13,3.13,0,0,1,3.13-3.13h79.4a3.13,3.13,0,0,1,3.12,3.13V62.45H360V32.82A5.71,5.71,0,0,0,354.28,27.11Z",
    fill: "#e1e1e2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.64,
    y: 96.93,
    width: 121.57,
    height: 88.81,
    rx: 5.44,
    fill: "#A9CEF4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70.43,
    y: 123.23,
    width: 12.93,
    height: 46.56,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 150.39,
    width: 12.93,
    height: 19.4,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 110.96,
    y: 137.88,
    width: 12.93,
    height: 31.9,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131.39,
    y: 144.35,
    width: 12.93,
    height: 25.44,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 151.81,
    y: 112.45,
    width: 12.93,
    height: 57.34,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47.65,
    y: 297.91,
    width: 120.07,
    height: 159.77,
    rx: 8.37,
    fill: "#A9CEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.44,314.12v27.45a3.74,3.74,0,0,1-3.75,3.75H63.17a3.76,3.76,0,0,1-3.76-3.75V314.12a3.77,3.77,0,0,1,3.76-3.76H153A3.75,3.75,0,0,1,156.44,314.12Z",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 59.41,
    y: 356.05,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 84.28,
    y: 356.05,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 109.16,
    y: 356.05,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 134.03,
    y: 356.05,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 59.73,
    y: 380.62,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 84.61,
    y: 380.62,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 109.48,
    y: 380.62,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 134.35,
    y: 380.62,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 59.73,
    y: 405.18,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 84.61,
    y: 405.18,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 109.48,
    y: 405.18,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 134.35,
    y: 405.18,
    width: 21.28,
    height: 44.14,
    rx: 2.71,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 59.73,
    y: 429.75,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 84.61,
    y: 429.75,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 109.48,
    y: 429.75,
    width: 21.28,
    height: 19.57,
    rx: 2.71,
    fill: "#21272D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 229.18,
    cy: 357.03,
    r: 44.35,
    fill: "#e1e1e2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 290.29,
    y: 320.29,
    width: 77.77,
    height: 21.72,
    rx: 3.4,
    fill: "#e1e1e2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 290.29,
    y: 352.63,
    width: 150.14,
    height: 5.88,
    fill: "#e1e1e2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 290.29,
    y: 364.38,
    width: 150.14,
    height: 5.88,
    fill: "#e1e1e2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 290.29,
    y: 377.75,
    width: 150.14,
    height: 5.88,
    fill: "#e1e1e2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 290.29,
    y: 388.97,
    width: 25.24,
    height: 5.88,
    fill: "#e1e1e2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 332.37,
    y: 390.19,
    width: 18.85,
    height: 5.88,
    fill: "#e1e1e2"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 365.36,
    y: 390.19,
    width: 25.62,
    height: 5.88,
    fill: "#e1e1e2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 345.32 84.28 310.36 105.56 310.36 84.28 345.32 63.17 345.32",
    fill: "#A9CEF4",
    opacity: 0.22
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.95 345.32 112.55 310.36 117.52 310.36 97.63 345.32 91.95 345.32",
    fill: "#A9CEF4",
    opacity: 0.22
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.65 345.32 133.08 310.36 141.66 310.36 119.8 345.32 110.65 345.32",
    fill: "#A9CEF4",
    opacity: 0.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.44,314.12v5.26l-16.68,25.94h-9.33L153,310.37A3.75,3.75,0,0,1,156.44,314.12Z",
    fill: "#A9CEF4",
    opacity: 0.22
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.27,218.17a52.51,52.51,0,0,0-15.41,37.22H193a114.08,114.08,0,0,1,33.53-80.94Z",
    fill: "#A9CEF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.27,218.17a52.51,52.51,0,0,0-15.41,37.22H193a114.08,114.08,0,0,1,33.53-80.94Z",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.86,256.82H193a1.43,1.43,0,0,1-1.43-1.43,115.11,115.11,0,0,1,33.95-81.95,1.42,1.42,0,0,1,2,0l43.72,43.72a1.42,1.42,0,0,1,0,2,50.91,50.91,0,0,0-15,36.21A1.43,1.43,0,0,1,254.86,256.82ZM194.45,254h59a53.6,53.6,0,0,1,14.82-35.78l-41.72-41.72A112.31,112.31,0,0,0,194.45,254Z",
    fill: "#21272D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.49,140.92v61.84a52.49,52.49,0,0,0-37.22,15.41l-43.72-43.72A114.08,114.08,0,0,1,307.49,140.92Z",
    fill: "#A9CEF4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M307.49,140.92v61.84a52.49,52.49,0,0,0-37.22,15.41l-43.72-43.72A114.08,114.08,0,0,1,307.49,140.92Z",
    opacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.27,219.6a1.43,1.43,0,0,1-1-.42l-43.72-43.72a1.42,1.42,0,0,1,0-2,115.13,115.13,0,0,1,82-33.95,1.43,1.43,0,0,1,1.43,1.43v61.84a1.42,1.42,0,0,1-1.43,1.42,50.91,50.91,0,0,0-36.21,15A1.42,1.42,0,0,1,270.27,219.6Zm-41.7-45.15,41.71,41.72a53.69,53.69,0,0,1,35.78-14.82v-59A112.3,112.3,0,0,0,228.57,174.45Z",
    fill: "#21272D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M388.44,174.45l-43.73,43.72a52.49,52.49,0,0,0-37.22-15.41V140.92A114.12,114.12,0,0,1,388.44,174.45Z",
    fill: "#A9CEF4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M388.44,174.45l-43.73,43.72a52.49,52.49,0,0,0-37.22-15.41V140.92A114.12,114.12,0,0,1,388.44,174.45Z",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M344.71,219.6a1.43,1.43,0,0,1-1-.42,50.91,50.91,0,0,0-36.21-15,1.42,1.42,0,0,1-1.43-1.42V140.92a1.43,1.43,0,0,1,1.43-1.43,115.17,115.17,0,0,1,82,33.95,1.44,1.44,0,0,1,0,2l-43.73,43.72A1.42,1.42,0,0,1,344.71,219.6Zm-35.79-18.25a53.67,53.67,0,0,1,35.78,14.82l41.71-41.72a112.27,112.27,0,0,0-77.49-32.1Z",
    fill: "#21272D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M422,255.39H360.13a52.47,52.47,0,0,0-15.42-37.22l43.73-43.72A114.12,114.12,0,0,1,422,255.39Z",
    fill: "#A9CEF4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M422,256.82H360.13a1.43,1.43,0,0,1-1.43-1.43,50.91,50.91,0,0,0-15-36.21,1.44,1.44,0,0,1,0-2l43.73-43.72a1.42,1.42,0,0,1,2,0,115.15,115.15,0,0,1,33.95,81.95A1.43,1.43,0,0,1,422,256.82ZM361.54,254h59a112.27,112.27,0,0,0-32.1-77.5l-41.71,41.72A53.7,53.7,0,0,1,361.54,254Z",
    fill: "#21272D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.75,128.83a8.38,8.38,0,0,1-3.29-3.12,9.08,9.08,0,0,1,0-9,8.38,8.38,0,0,1,3.29-3.12,9.74,9.74,0,0,1,4.7-1.12,10,10,0,0,1,4,.77,8,8,0,0,1,3,2.23l-2.52,2.32a5.4,5.4,0,0,0-4.25-2,5.65,5.65,0,0,0-2.81.69,4.86,4.86,0,0,0-1.92,1.92,6,6,0,0,0,0,5.61,4.92,4.92,0,0,0,1.92,1.92,5.65,5.65,0,0,0,2.81.69,5.36,5.36,0,0,0,4.25-2l2.52,2.33a7.85,7.85,0,0,1-3,2.24,9.86,9.86,0,0,1-4,.78A9.7,9.7,0,0,1,201.75,128.83Z",
    fill: "#21272D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M229.26,129.67,226,125h-3.6v4.72h-3.92V112.74h7.33a9.44,9.44,0,0,1,3.91.75,5.59,5.59,0,0,1,3.44,5.39,5.51,5.51,0,0,1-3.48,5.35l3.8,5.44Zm-1-13a4.13,4.13,0,0,0-2.69-.76h-3.19v5.9h3.19a4.13,4.13,0,0,0,2.69-.77,3.05,3.05,0,0,0,0-4.37Z",
    fill: "#21272D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.78,126.52v3.15H238.67V112.74h12.79v3.14h-8.9v3.68h7.86v3h-7.86v3.91Z",
    fill: "#21272D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M257.31,112.74H265a10.85,10.85,0,0,1,4.88,1.05,7.94,7.94,0,0,1,3.29,3,9,9,0,0,1,0,8.9,8,8,0,0,1-3.29,3,10.85,10.85,0,0,1-4.88,1h-7.69Zm7.5,13.71a5.71,5.71,0,0,0,4.05-1.41,5.62,5.62,0,0,0,0-7.67,5.71,5.71,0,0,0-4.05-1.41h-3.58v10.49Z",
    fill: "#21272D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M279.71,112.74h3.92v16.93h-3.92Z",
    fill: "#21272D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M293.57,115.93h-5.42v-3.19H302.9v3.19h-5.42v13.74h-3.91Z",
    fill: "#21272D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M318.37,129.41a9,9,0,0,1-3-1.41l1.33-3a8.89,8.89,0,0,0,2.58,1.28,9.8,9.8,0,0,0,3,.48,4.82,4.82,0,0,0,2.47-.49,1.5,1.5,0,0,0,.8-1.32,1.26,1.26,0,0,0-.47-1,3.56,3.56,0,0,0-1.21-.64c-.5-.17-1.16-.34-2-.54a26.12,26.12,0,0,1-3.17-.92,5.06,5.06,0,0,1-2.11-1.47,4,4,0,0,1-.89-2.71,4.73,4.73,0,0,1,.8-2.67,5.39,5.39,0,0,1,2.41-1.9,9.76,9.76,0,0,1,3.93-.7,13,13,0,0,1,3.17.39,9.07,9.07,0,0,1,2.71,1.11l-1.21,3a9.54,9.54,0,0,0-4.7-1.33,4.47,4.47,0,0,0-2.43.53,1.65,1.65,0,0,0-.78,1.41,1.36,1.36,0,0,0,.91,1.29,14.55,14.55,0,0,0,2.76.84,27.69,27.69,0,0,1,3.17.91,5.25,5.25,0,0,1,2.12,1.46,3.87,3.87,0,0,1,.88,2.68,4.63,4.63,0,0,1-.81,2.65,5.45,5.45,0,0,1-2.43,1.9,10,10,0,0,1-3.94.7A13.58,13.58,0,0,1,318.37,129.41Z",
    fill: "#21272D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M338,128.83a8.31,8.31,0,0,1-3.29-3.12,9.08,9.08,0,0,1,0-9,8.31,8.31,0,0,1,3.29-3.12,9.74,9.74,0,0,1,4.7-1.12,10,10,0,0,1,4,.77,8,8,0,0,1,3,2.23l-2.51,2.32a5.42,5.42,0,0,0-4.26-2,5.62,5.62,0,0,0-2.8.69,4.82,4.82,0,0,0-1.93,1.92,6.13,6.13,0,0,0,0,5.61,4.88,4.88,0,0,0,1.93,1.92,5.62,5.62,0,0,0,2.8.69,5.38,5.38,0,0,0,4.26-2l2.51,2.33a7.74,7.74,0,0,1-3,2.24,9.93,9.93,0,0,1-4,.78A9.7,9.7,0,0,1,338,128.83Z",
    fill: "#21272D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M357.76,128.82a8.46,8.46,0,0,1-3.31-3.13,8.65,8.65,0,0,1,3.31-12.11,10.55,10.55,0,0,1,9.5,0,8.62,8.62,0,0,1,3.31,3.14,8.92,8.92,0,0,1,0,9,8.59,8.59,0,0,1-3.31,3.13,10.47,10.47,0,0,1-9.5,0Zm7.46-2.89a4.94,4.94,0,0,0,1.9-1.92,6,6,0,0,0,0-5.61,4.87,4.87,0,0,0-1.9-1.92,5.65,5.65,0,0,0-5.41,0,4.87,4.87,0,0,0-1.9,1.92,6,6,0,0,0,0,5.61,4.94,4.94,0,0,0,1.9,1.92,5.65,5.65,0,0,0,5.41,0Z",
    fill: "#21272D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M387.93,129.67,384.67,125h-3.6v4.72h-3.92V112.74h7.32a9.41,9.41,0,0,1,3.91.75,5.73,5.73,0,0,1,2.55,2.13,5.82,5.82,0,0,1,.9,3.26,5.69,5.69,0,0,1-.91,3.25,5.75,5.75,0,0,1-2.58,2.1l3.8,5.44Zm-1-13a4.1,4.1,0,0,0-2.68-.76h-3.19v5.9h3.19a4.1,4.1,0,0,0,2.68-.77,3.05,3.05,0,0,0,0-4.37Z",
    fill: "#21272D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M410.45,126.52v3.15H397.34V112.74h12.79v3.14h-8.9v3.68h7.86v3h-7.86v3.91Z",
    fill: "#21272D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M375.75,268.39h2.17v4.16a6.34,6.34,0,0,1-1.93,1,7.7,7.7,0,0,1-2.21.34,6,6,0,0,1-2.87-.68,5.13,5.13,0,0,1-2-1.89,5.54,5.54,0,0,1,0-5.46,5.06,5.06,0,0,1,2-1.88,6.05,6.05,0,0,1,2.9-.68,6.35,6.35,0,0,1,2.44.45,4.84,4.84,0,0,1,1.85,1.31l-1.52,1.41a3.55,3.55,0,0,0-2.65-1.16,3.61,3.61,0,0,0-1.74.41,3,3,0,0,0-1.19,1.16,3.44,3.44,0,0,0-.42,1.71,3.4,3.4,0,0,0,.42,1.7,3,3,0,0,0,1.18,1.16,3.45,3.45,0,0,0,1.72.42,3.85,3.85,0,0,0,1.84-.44Z",
    fill: "#21272D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2,273.16a5,5,0,0,1-2-1.9,5.46,5.46,0,0,1,0-5.42,5,5,0,0,1,2-1.9,6.4,6.4,0,0,1,5.74,0,5.23,5.23,0,0,1,0,9.22,6.31,6.31,0,0,1-5.74,0Zm4.51-1.75a3,3,0,0,0,1.15-1.16,3.65,3.65,0,0,0,0-3.4,3.05,3.05,0,0,0-1.15-1.16,3.41,3.41,0,0,0-3.28,0,3.05,3.05,0,0,0-1.15,1.16,3.73,3.73,0,0,0,0,3.4,3,3,0,0,0,1.15,1.16,3.41,3.41,0,0,0,3.28,0Z",
    fill: "#21272D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M394.54,273.16a5.08,5.08,0,0,1-2-1.9,5.46,5.46,0,0,1,0-5.42,5.08,5.08,0,0,1,2-1.9,6.42,6.42,0,0,1,5.75,0,5.22,5.22,0,0,1,2,1.9,5.4,5.4,0,0,1,0,5.42,5.22,5.22,0,0,1-2,1.9,6.33,6.33,0,0,1-5.75,0Zm4.52-1.75a3.05,3.05,0,0,0,1.15-1.16,3.73,3.73,0,0,0,0-3.4,3.12,3.12,0,0,0-1.15-1.16,3.41,3.41,0,0,0-3.28,0,3.05,3.05,0,0,0-1.15,1.16,3.65,3.65,0,0,0,0,3.4,3,3,0,0,0,1.15,1.16,3.41,3.41,0,0,0,3.28,0Z",
    fill: "#21272D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M404.81,263.43h4.65a6.5,6.5,0,0,1,3,.64,4.8,4.8,0,0,1,2,1.79,5.45,5.45,0,0,1,0,5.38,4.8,4.8,0,0,1-2,1.79,6.5,6.5,0,0,1-3,.64h-4.65Zm4.53,8.3a3.44,3.44,0,0,0,2.45-.86,3.39,3.39,0,0,0,0-4.64,3.43,3.43,0,0,0-2.45-.85h-2.16v6.35Z",
    fill: "#21272D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M304.64,231.45l76-12.76a3.66,3.66,0,0,1,1.92,7l-72,27.63a11.4,11.4,0,0,1-8.17-21.29A12.86,12.86,0,0,1,304.64,231.45Z",
    fill: "#e1e1e2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.45,
    cy: 242.7,
    r: 6.1,
    fill: "#A9CEF4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M206.46,263.88a3.67,3.67,0,0,1,1.55,1.29,3.58,3.58,0,0,1,.54,2,3.54,3.54,0,0,1-.54,2,3.47,3.47,0,0,1-1.55,1.29,5.71,5.71,0,0,1-2.36.45H202v2.82h-2.37V263.43h4.43A5.71,5.71,0,0,1,206.46,263.88Zm-.87,4.58a1.84,1.84,0,0,0,0-2.64,2.52,2.52,0,0,0-1.62-.46H202v3.56H204A2.52,2.52,0,0,0,205.59,268.46Z",
    fill: "#21272D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M212.46,273.16a5.23,5.23,0,0,1,0-9.22,6.4,6.4,0,0,1,5.74,0,5.22,5.22,0,0,1,0,9.22,6.31,6.31,0,0,1-5.74,0Zm4.51-1.75a3,3,0,0,0,1.15-1.16,3.65,3.65,0,0,0,0-3.4,3.05,3.05,0,0,0-1.15-1.16,3.39,3.39,0,0,0-3.27,0,3.05,3.05,0,0,0-1.15,1.16,3.65,3.65,0,0,0,0,3.4,3,3,0,0,0,1.15,1.16,3.39,3.39,0,0,0,3.27,0Z",
    fill: "#21272D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M224.81,273.16a5.09,5.09,0,0,1-2.73-4.61,5.18,5.18,0,0,1,.72-2.71,5.11,5.11,0,0,1,2-1.9,6.4,6.4,0,0,1,5.74,0,5.23,5.23,0,0,1,0,9.22,6.31,6.31,0,0,1-5.74,0Zm4.51-1.75a3,3,0,0,0,1.15-1.16,3.65,3.65,0,0,0,0-3.4,3.05,3.05,0,0,0-1.15-1.16,3.41,3.41,0,0,0-3.28,0,3,3,0,0,0-1.14,1.16,3.65,3.65,0,0,0,0,3.4,3,3,0,0,0,1.14,1.16,3.41,3.41,0,0,0,3.28,0Z",
    fill: "#21272D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M241.6,273.67l-2-2.85h-2.18v2.85h-2.37V263.43h4.43a5.76,5.76,0,0,1,2.37.45,3.64,3.64,0,0,1,1.54,1.29,3.58,3.58,0,0,1,.54,2,3.42,3.42,0,0,1-.55,2,3.38,3.38,0,0,1-1.55,1.27l2.29,3.29Zm-.6-7.85a2.55,2.55,0,0,0-1.63-.46h-1.93v3.57h1.93a2.44,2.44,0,0,0,1.63-.47,1.86,1.86,0,0,0,0-2.64Z",
    fill: "#21272D"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 429.55,
    y: 79.44,
    width: 97.93,
    height: 27.51,
    rx: 6.08,
    fill: "#A9CEF4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M447.33,88.88A4.31,4.31,0,1,1,443,84.57,4.31,4.31,0,0,1,447.33,88.88Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M443,94.65a7.94,7.94,0,0,0-7.95,7.94h15.89A7.94,7.94,0,0,0,443,94.65Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M520,88.88h-62.9a2.16,2.16,0,0,1-2.16-2.15h0a2.16,2.16,0,0,1,2.16-2.16H520a2.16,2.16,0,0,1,2.15,2.16h0A2.15,2.15,0,0,1,520,88.88Z",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M461.47,93.33l1.08,2.19a.54.54,0,0,0,.39.28l2.41.35a.51.51,0,0,1,.28.87l-1.75,1.7a.49.49,0,0,0-.14.45l.41,2.4a.51.51,0,0,1-.74.53L461.26,101a.51.51,0,0,0-.48,0l-2.16,1.13a.5.5,0,0,1-.73-.53l.41-2.4a.5.5,0,0,0-.15-.45L456.41,97a.51.51,0,0,1,.28-.87l2.41-.35a.51.51,0,0,0,.38-.28l1.08-2.19A.51.51,0,0,1,461.47,93.33Z",
    fill: "#21272D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M475.46,93.33l1.08,2.19a.51.51,0,0,0,.38.28l2.41.35a.51.51,0,0,1,.28.87l-1.74,1.7a.5.5,0,0,0-.15.45l.41,2.4a.5.5,0,0,1-.73.53L475.24,101a.49.49,0,0,0-.47,0l-2.16,1.13a.51.51,0,0,1-.74-.53l.41-2.4a.49.49,0,0,0-.14-.45L470.39,97a.51.51,0,0,1,.28-.87l2.41-.35a.54.54,0,0,0,.39-.28l1.08-2.19A.51.51,0,0,1,475.46,93.33Z",
    fill: "#21272D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M489.44,93.33l1.08,2.19a.52.52,0,0,0,.38.28l2.41.35a.51.51,0,0,1,.29.87l-1.75,1.7a.49.49,0,0,0-.14.45l.41,2.4a.51.51,0,0,1-.74.53L489.22,101a.49.49,0,0,0-.47,0l-2.16,1.13a.51.51,0,0,1-.74-.53l.42-2.4a.52.52,0,0,0-.15-.45L484.37,97a.51.51,0,0,1,.29-.87l2.41-.35a.52.52,0,0,0,.38-.28l1.08-2.19A.51.51,0,0,1,489.44,93.33Z",
    fill: "#21272D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M503.43,93.33l1.07,2.19a.54.54,0,0,0,.39.28l2.41.35a.51.51,0,0,1,.28.87l-1.74,1.7a.5.5,0,0,0-.15.45l.41,2.4a.51.51,0,0,1-.74.53L503.21,101a.51.51,0,0,0-.48,0l-2.15,1.13a.51.51,0,0,1-.74-.53l.41-2.4a.5.5,0,0,0-.15-.45L498.36,97a.51.51,0,0,1,.28-.87l2.41-.35a.54.54,0,0,0,.39-.28l1.07-2.19A.52.52,0,0,1,503.43,93.33Z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M517.41,93.33l1.08,2.19a.52.52,0,0,0,.38.28l2.41.35a.51.51,0,0,1,.28.87l-1.74,1.7a.52.52,0,0,0-.15.45l.42,2.4a.51.51,0,0,1-.74.53L517.19,101a.49.49,0,0,0-.47,0l-2.16,1.13a.51.51,0,0,1-.74-.53l.41-2.4a.49.49,0,0,0-.14-.45L512.34,97a.51.51,0,0,1,.28-.87L515,95.8a.54.54,0,0,0,.38-.28l1.08-2.19A.51.51,0,0,1,517.41,93.33Z",
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 491.42,
    y: 159.27,
    width: 97.93,
    height: 27.51,
    rx: 6.08,
    fill: "#A9CEF4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M509.2,168.71a4.31,4.31,0,1,1-4.31-4.31A4.31,4.31,0,0,1,509.2,168.71Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M504.82,174.47a8,8,0,0,0-7.95,7.95h15.89A7.94,7.94,0,0,0,504.82,174.47Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M581.84,168.71h-62.9a2.16,2.16,0,0,1-2.16-2.15h0a2.16,2.16,0,0,1,2.16-2.16h62.9a2.16,2.16,0,0,1,2.16,2.16h0A2.16,2.16,0,0,1,581.84,168.71Z",
    opacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M523.35,173.16l1.07,2.18a.52.52,0,0,0,.39.28l2.41.35a.51.51,0,0,1,.28.87l-1.74,1.7a.51.51,0,0,0-.15.45l.41,2.4a.51.51,0,0,1-.74.54l-2.15-1.13a.51.51,0,0,0-.48,0l-2.15,1.13a.51.51,0,0,1-.74-.54l.41-2.4a.51.51,0,0,0-.15-.45l-1.74-1.7a.51.51,0,0,1,.28-.87l2.41-.35a.52.52,0,0,0,.39-.28l1.07-2.18A.51.51,0,0,1,523.35,173.16Z",
    fill: "#21272D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M537.33,173.16l1.08,2.18a.5.5,0,0,0,.38.28l2.41.35a.51.51,0,0,1,.29.87l-1.75,1.7a.54.54,0,0,0-.15.45l.42,2.4a.51.51,0,0,1-.74.54l-2.16-1.13a.49.49,0,0,0-.47,0l-2.16,1.13a.51.51,0,0,1-.74-.54l.41-2.4a.51.51,0,0,0-.14-.45l-1.75-1.7a.51.51,0,0,1,.29-.87l2.41-.35a.5.5,0,0,0,.38-.28l1.08-2.18A.51.51,0,0,1,537.33,173.16Z",
    fill: "#21272D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M551.31,173.16l1.08,2.18a.52.52,0,0,0,.39.28l2.41.35a.51.51,0,0,1,.28.87l-1.75,1.7a.51.51,0,0,0-.14.45l.41,2.4a.51.51,0,0,1-.74.54l-2.16-1.13a.49.49,0,0,0-.47,0l-2.16,1.13a.5.5,0,0,1-.73-.54l.41-2.4a.51.51,0,0,0-.15-.45l-1.74-1.7a.51.51,0,0,1,.28-.87l2.41-.35a.48.48,0,0,0,.38-.28l1.08-2.18A.51.51,0,0,1,551.31,173.16Z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M565.3,173.16l1.08,2.18a.48.48,0,0,0,.38.28l2.41.35a.51.51,0,0,1,.28.87l-1.74,1.7a.51.51,0,0,0-.15.45l.41,2.4a.5.5,0,0,1-.73.54l-2.16-1.13a.49.49,0,0,0-.47,0l-2.16,1.13a.51.51,0,0,1-.74-.54l.41-2.4a.51.51,0,0,0-.14-.45l-1.75-1.7a.51.51,0,0,1,.28-.87l2.41-.35a.52.52,0,0,0,.39-.28l1.08-2.18A.51.51,0,0,1,565.3,173.16Z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M579.28,173.16l1.08,2.18a.5.5,0,0,0,.38.28l2.41.35a.51.51,0,0,1,.29.87l-1.75,1.7a.51.51,0,0,0-.14.45l.41,2.4a.51.51,0,0,1-.74.54l-2.16-1.13a.49.49,0,0,0-.47,0l-2.16,1.13a.51.51,0,0,1-.74-.54l.42-2.4a.54.54,0,0,0-.15-.45l-1.75-1.7a.51.51,0,0,1,.29-.87l2.41-.35a.5.5,0,0,0,.38-.28l1.08-2.18A.51.51,0,0,1,579.28,173.16Z",
    fill: "#fff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 185.15,
    y: 485.29,
    width: 133.24,
    height: 37.43,
    rx: 8.27,
    fill: "#A9CEF4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M209.34,498.14a5.86,5.86,0,1,1-5.86-5.87A5.86,5.86,0,0,1,209.34,498.14Z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M203.38,506a10.81,10.81,0,0,0-10.81,10.81h21.62A10.81,10.81,0,0,0,203.38,506Z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M308.17,498.14H222.59a2.93,2.93,0,0,1-2.93-2.93h0a2.94,2.94,0,0,1,2.93-2.94h85.58a2.94,2.94,0,0,1,2.93,2.94h0A2.93,2.93,0,0,1,308.17,498.14Z",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M228.59,504.19l1.46,3a.7.7,0,0,0,.53.38l3.28.48a.69.69,0,0,1,.38,1.18l-2.37,2.31a.68.68,0,0,0-.2.62l.56,3.26a.7.7,0,0,1-1,.73l-2.93-1.54a.68.68,0,0,0-.65,0l-2.93,1.54a.69.69,0,0,1-1-.73l.56-3.26a.74.74,0,0,0-.2-.62l-2.38-2.31a.69.69,0,0,1,.39-1.18l3.28-.48a.68.68,0,0,0,.52-.38l1.47-3A.69.69,0,0,1,228.59,504.19Z",
    fill: "#21272D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M247.61,504.19l1.47,3a.68.68,0,0,0,.52.38l3.28.48a.69.69,0,0,1,.39,1.18l-2.38,2.31a.71.71,0,0,0-.2.62l.56,3.26a.69.69,0,0,1-1,.73l-2.94-1.54a.66.66,0,0,0-.64,0l-2.93,1.54a.69.69,0,0,1-1-.73l.56-3.26a.68.68,0,0,0-.2-.62l-2.37-2.31a.69.69,0,0,1,.38-1.18l3.28-.48a.66.66,0,0,0,.52-.38l1.47-3A.69.69,0,0,1,247.61,504.19Z",
    fill: "#21272D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M266.64,504.19l1.47,3a.66.66,0,0,0,.52.38l3.28.48a.69.69,0,0,1,.38,1.18l-2.37,2.31a.71.71,0,0,0-.2.62l.56,3.26a.69.69,0,0,1-1,.73l-2.93-1.54a.66.66,0,0,0-.64,0l-2.94,1.54a.69.69,0,0,1-1-.73l.56-3.26a.71.71,0,0,0-.2-.62l-2.38-2.31a.69.69,0,0,1,.39-1.18l3.28-.48a.68.68,0,0,0,.52-.38l1.47-3A.69.69,0,0,1,266.64,504.19Z",
    fill: "#21272D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M285.67,504.19l1.46,3a.68.68,0,0,0,.52.38l3.28.48a.69.69,0,0,1,.39,1.18l-2.38,2.31a.74.74,0,0,0-.2.62l.57,3.26a.7.7,0,0,1-1,.73l-2.93-1.54a.68.68,0,0,0-.65,0l-2.93,1.54a.7.7,0,0,1-1-.73l.56-3.26a.68.68,0,0,0-.2-.62l-2.37-2.31a.69.69,0,0,1,.38-1.18l3.28-.48a.68.68,0,0,0,.53-.38l1.46-3A.7.7,0,0,1,285.67,504.19Z",
    fill: "#21272D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M304.69,504.19l1.47,3a.66.66,0,0,0,.52.38L310,508a.69.69,0,0,1,.38,1.18L308,511.51a.71.71,0,0,0-.2.62l.56,3.26a.69.69,0,0,1-1,.73l-2.94-1.54a.66.66,0,0,0-.64,0l-2.94,1.54a.69.69,0,0,1-1-.73l.56-3.26a.71.71,0,0,0-.2-.62l-2.37-2.31a.69.69,0,0,1,.38-1.18l3.28-.48a.66.66,0,0,0,.52-.38l1.47-3A.69.69,0,0,1,304.69,504.19Z",
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 698.44,
    y: 482.38,
    width: 8.84,
    height: 145.87,
    transform: "translate(1405.71 1110.62) rotate(-180)",
    fill: "#2e3135"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M647.91,648.82h1.87v-4.55a15.42,15.42,0,0,1,15.39-15.39H736a20,20,0,0,1,19.94,19.94h1.88A21.84,21.84,0,0,0,736,627H665.17a17.28,17.28,0,0,0-17.26,17.26Z",
    fill: "#3f4347"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M721.72,645.64l1.78-.59c-.19-.58-4.86-14.14-17.91-18l-.54,1.8C717.18,632.44,721.68,645.51,721.72,645.64Z",
    fill: "#3f4347"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.46,
    cy: 648.82,
    r: 6.96,
    fill: "#2e3135"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.71,
    cy: 648.82,
    r: 6.96,
    fill: "#2e3135"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.69,
    cy: 648.82,
    r: 6.96,
    fill: "#2e3135"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "653.47 475.56 763.58 475.56 779.25 317.9 653.47 317.9 653.47 475.56",
    fill: "#2e3135"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 631.53,
    width: 83.51,
    height: 5.09,
    transform: "translate(1551.05 884.63) rotate(152.22)",
    fill: "#21272D"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 648.06,
    y: 569.55,
    width: 31.85,
    height: 21.46,
    transform: "translate(-193.92 376.32) rotate(-27.78)",
    fill: "#f9b499"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M628,651.29l73.88-38.92-18.83-30-24.63,13a15.08,15.08,0,0,0-2.28-5.33,5.64,5.64,0,0,0-1.75-1.69c-2.36-1.39-3.56.2-4.14,1.71a7.4,7.4,0,0,0-.44,3.13c.49,8.35-1.42,16.92-3.47,23.41a34.38,34.38,0,0,1-6.46,11.75,34.82,34.82,0,0,1-3.53,3.66C624.61,642.56,628,651.29,628,651.29Z",
    fill: "#A9CEF4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M639.91,628.31c27.05-7.38,18.54-33,18.54-33a15.08,15.08,0,0,0-2.28-5.33,5.64,5.64,0,0,0-1.75-1.69c-2.36-1.39-3.56.2-4.14,1.71a7.4,7.4,0,0,0-.44,3.13c.49,8.35-1.42,16.92-3.47,23.41A34.38,34.38,0,0,1,639.91,628.31Z",
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "673.08 563.37 678.62 573.88 646.35 577.45 673.08 563.37",
    fill: "#f7a48b"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 556.62,
    y: 593.91,
    width: 31.85,
    height: 21.46,
    fill: "#f9b499"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M507.64,650.7h83.51l-2.68-35.33H560.64a15.34,15.34,0,0,0,.46-5.78,5.58,5.58,0,0,0-.76-2.31c-1.44-2.33-3.24-1.48-4.46-.42a7.23,7.23,0,0,0-1.84,2.57c-3.47,7.61-9.15,14.3-14,19.09a34.12,34.12,0,0,1-11.19,7.38,35.49,35.49,0,0,1-4.83,1.6C508.68,641.39,507.64,650.7,507.64,650.7Z",
    fill: "#A9CEF4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M528.86,635.9c27.37,6.09,31.78-20.53,31.78-20.53a15.34,15.34,0,0,0,.46-5.78,5.58,5.58,0,0,0-.76-2.31c-1.44-2.33-3.24-1.48-4.46-.42a7.23,7.23,0,0,0-1.84,2.57c-3.47,7.61-9.15,14.3-14,19.09A34.12,34.12,0,0,1,528.86,635.9Z",
    opacity: 0.2
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "588.47 593.91 588.47 605.79 558.26 593.91 588.47 593.91",
    fill: "#f7a48b"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M625.33,303.75c.48.4-8.39,14.15-8.39,14.15l-46.67-38.77a7.77,7.77,0,0,1-1.1-1.12c-.59-.76-1.71-2.16-3.12-3.83a141.14,141.14,0,0,1-9.89-13.53c-1.16-1.77-2.63-3.11-4.24-2.34,0,0-4.1.89,0,10.88L527,260.27a2.49,2.49,0,0,0-3,1.16l-.18.33a2.49,2.49,0,0,0,.89,3.31l11.69,7.11a.27.27,0,0,1-.24.47l-13.29-5.32a2.49,2.49,0,0,0-3.29,1.57l-.33,1.05a2.47,2.47,0,0,0,1.35,3l12.69,5.72a.27.27,0,0,1-.19.5l-12.37-3.64a2.48,2.48,0,0,0-3,1.43h0a2.49,2.49,0,0,0,1.27,3.22l14.24,6.4a.27.27,0,0,1-.13.51l-7.69-.62a2.48,2.48,0,0,0-2.51,1.57l-.1.26a2.48,2.48,0,0,0,1.21,3.13h0a123.17,123.17,0,0,1,18.47,11.21l66.39,48.79a33.71,33.71,0,0,0,16.8,6.53c7.79.73,17-1.16,20.07-12.91L658.09,321l-29.71-21.21Z",
    fill: "#f9b499"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 579.21,
    y: 390.53,
    width: 46.45,
    height: 8.1,
    transform: "translate(1204.87 789.15) rotate(-180)",
    fill: "#21272D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M788.79,328.44,773.11,485.29H661.31v-5.22A12.74,12.74,0,0,1,674,467.33h80.53l15.14-140.86a9.6,9.6,0,0,1,9.54-8.57h0A9.59,9.59,0,0,1,788.79,328.44Z",
    fill: "#3f4347"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M745.92,393.48v39.37s-2.32,29.78-33.67,34.48H661.31l37.61,91.31-79.94,29-5.87-34.1-5.88,40.37H528.86l16.85-120.7s1.79-51.64,52.9-63.48l39.48-10.5,13.77-1.59,89.78-7.11Z",
    fill: "#21272D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M686.89,552.11l.56-.27-39.08-83.43a6.31,6.31,0,0,1,5.72-9h49.14a46,46,0,0,0,18.63-6.22c8.52-5.14,18.71-15.62,18.91-36.41V396.06h-.62v20.72c-.2,20.49-10.22,30.82-18.59,35.87a45.23,45.23,0,0,1-18.35,6.14H654.09a6.94,6.94,0,0,0-6.28,9.88Z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M736.23,437l.24-.57c-20.09-8.73-15.73-39.35-15.68-39.66l-.62-.09C720.12,397,715.69,428.09,736.23,437Z",
    fill: "#fff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "613.11 553.54 593.51 460.28 607.23 593.91 613.11 553.54",
    opacity: 0.2
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "756.72 410.88 788.84 655.78 797.77 655.78 770.01 410.88 756.72 410.88",
    fill: "#9ea0a3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M756.71,333.47l-.66-15.57s3.59-37.69-30.87-41.74h-74.3s-10.65-1.38-19,12.45l-9.52,12.69,24,19.71s-7.26,4.76-6.12,12.47a15.25,15.25,0,0,0,7.51,13v40.69H718.6V339.32Z",
    fill: "#A9CEF4"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "718.6 339.32 713.22 341.01 714.56 302.2 707.34 358.68 647.74 371.94 718.6 365.02 718.6 339.32",
    opacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M681.28,276.15v-8.38s-15.91-3.35-17.09-21.86c0,0-.43,8-8.36,17,0,0-6.72,7.43-7.76,13.28Z",
    fill: "#21272D"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "646.35 321 648.07 296.22 638.09 314.23 646.35 321",
    opacity: 0.2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 507.64,
    y: 650.7,
    width: 83.51,
    height: 5.09,
    transform: "translate(1098.79 1306.48) rotate(-180)",
    fill: "#21272D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M552.7,271.16s2.47,5.21,7,7.68",
    fill: "none",
    stroke: "#f7a48b",
    strokeMiterlimit: 10
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.02 410.93 407.04 655.74 398.11 655.74 427.73 410.93 441.02 410.93",
    fill: "#9ea0a3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M706.8,250a48,48,0,0,0,2.43,22.75s4.55,6.07-2.87,9.28c0,0-24.18,6.6-25.08-5.89v-10Z",
    fill: "#f9b499"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M681.28,266.16v10s6.7.72,15.31-10A87.94,87.94,0,0,1,681.28,266.16Z",
    fill: "#f7a48b"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 664.19,
    y: 197.12,
    width: 45.04,
    height: 71.32,
    rx: 22.01,
    transform: "translate(1373.42 465.55) rotate(-180)",
    fill: "#f9b499"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M684.05,205.05s-1.31,10.59,13.65,19c0,0,5.71,4.34,5.13,13.55l6.4,8.31s.6,4.35-2.86,11a46.53,46.53,0,0,0,2.86,15.86,15,15,0,0,1,1.38,3.4H723.1a27.67,27.67,0,0,1,7.24.94,33.26,33.26,0,0,1,22.16,19.26c2.34,5.38,3.34,12.39,3.55,16.82v4.72h17s3-32.07-23.1-52.88a57.87,57.87,0,0,0-6.26-4.25c-3.69-2.21-13.84-10.29-17-33.51,0,0-1.07-35-28.2-34.62,0,0-36.34-3.2-34.22,29.8C664.19,222.44,670.94,208,684.05,205.05Z",
    fill: "#21272D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 709.23,
    cy: 239.3,
    rx: 6.56,
    ry: 8.03,
    fill: "#f9b499"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 379.71,
    y: 398.62,
    width: 438.41,
    height: 14.4,
    transform: "translate(1197.82 811.65) rotate(-180)",
    fill: "#e6e6e6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M753.9,333.9,756.71,371s1.24,19.21-16.47,25.85a29.58,29.58,0,0,1-10.71,1.79l-77.67-.95-36.65,4.23a1.7,1.7,0,0,1-1.9-1.69h0a1.7,1.7,0,0,1,.94-1.53l4.49-2.24a.42.42,0,0,0-.25-.79l-6.36,1.06a2.39,2.39,0,0,1-2.78-2.35h0a2.38,2.38,0,0,1,1.83-2.32l3.94-1a.42.42,0,0,0-.09-.82h-8.65a2.71,2.71,0,0,1-2.71-2.72h0a2.71,2.71,0,0,1,2.18-2.66l13.53-2.69a.41.41,0,0,0,0-.82l-11.62-.92a2.91,2.91,0,0,1-2.68-2.79h0a2.92,2.92,0,0,1,2.59-3l18-2a.45.45,0,0,0,0-.84l-5.42-2.42a3.24,3.24,0,0,1-1.65-4.25h0a3.23,3.23,0,0,1,4-1.77l25.17,8.66L718.6,365v-25.7Z",
    fill: "#f9b499"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "493.93 375.27 615 375.27 593.53 293.27 472.81 293.27 493.93 375.27",
    fill: "#21272D"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "598.87 293.27 593.53 293.27 615 375.27 619.73 375.27 598.87 293.27",
    fill: "#21272D"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "598.87 293.27 593.53 293.27 615 375.27 619.73 375.27 598.87 293.27",
    opacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M558.33,358.1,551,393.65H574.8a2.48,2.48,0,0,1,2.49,2.49h0a2.48,2.48,0,0,1-2.49,2.48H523.14a5.28,5.28,0,0,1-5-6.89l10.76-33.63Z",
    fill: "#21272D"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "558.33 358.1 562.24 358.1 555.01 393.65 550.98 393.65 558.33 358.1",
    fill: "#21272D"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "558.33 358.1 562.24 358.1 555.01 393.65 550.98 393.65 558.33 358.1",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanCreditAuthGraphicDark);
export default __webpack_public_path__ + "static/media/loanCreditAuthGraphicDark.1903bf5bec7f6a23b456f26b33ae7dea.svg";
export { ForwardRef as ReactComponent };